export default __webpack_public_path__ + "static/media/logo2.5c21433b.svg";